export default __webpack_public_path__ + "static/media/cityPedia.a3aa3635.png";